export const deliveryFeatureTranslationEN = {
  DeliveryFeature: {
    Component: {
      test_reflection: 'test reflection',
      search: 'search',
      csv_output: 'csv output',
      delete: 'delete',
      close: 'close',
      setting: 'setting',
    },
    Text: {
      distribution_setting_status_list: 'distribution setting status list',
      it_is_a_required_field: 'it is a required field',
      delivery_history_search: 'delivery history search',
      delivery_date: 'delivery date:',
      data_date: 'data date:',
      content: 'content:',
      approval_state: 'approval state:',
      delivery_status: 'delivery status:',
      new_distribution_setting: 'new distribution setting',
      apply: 'apply for distribution',
      list_of_distribution_status: 'list of distribution status',
      all: 'all',
      distribution_settings: 'distribution settings',
      distribution_unit: 'distribution unit',
      sales_type: 'sales type',
      counter_pattern: 'counter pattern',
    },
    Table: {
      selection: 'selection',
      distribution_no: 'distribution number',
      distribution_unit: 'distribution unit',
      sales_target: 'sales target',
      scheduled_distribution_date: 'scheduled distribution date',
      distribution_status: 'distribution status',
      approval_state: 'approval state',
      applicant: 'applicant',
      application_date: 'application date',
      confirmer: 'confirmer',
      date_confirmed: 'date confirmed',
      recognized: 'recognized',
      approval_date: 'approval date',
      store_code: 'store code',
      store_name: 'store name',
      sales_type: 'sales type',
      regular_pattern: 'regular pattern',
      distribution_date: 'distribution date',
      delivery_content: 'delivery content',
      delivery_creation_in_progress: 'Delivery creation in progress',
      delivery_created_successfully: 'Delivery was created successfully',
    },
  },
};
